import React from 'react';
import SignInForm from '../components/SignInForm';

// Sign-in screen for the listening app. It owns the .listening-theme dark palette
// wrapper, the NARRATORIA wordmark and the marketing tagline; the passwordless flow
// itself now lives in the shared SignInForm, so the same logic backs both this screen
// and the inline rent sign-in on the audiobook access card.
//
// Passwordless flow (in SignInForm): request a 6-digit code by email, verify it, then
// exchange it for a real Firebase session via a custom token. On success the app-wide
// auth-state change carries the reader into their library (the ListeningApp shell
// swaps this screen out), so there is nothing to do here on success.
function SignInScreen() {
  return (
    <div className="listening-theme min-h-screen w-full bg-background text-foreground flex flex-col items-center justify-center px-6 py-12">
      <div className="w-full max-w-sm">
        {/* Wordmark */}
        <h1 className="font-display text-primary text-5xl font-semibold tracking-wide text-center">
          NARRATORIA
        </h1>

        {/* mt-8 preserves the spacing the old step blocks had below the wordmark. */}
        <div className="mt-8">
          <SignInForm emailIntro="Your audiobooks, wherever you are." />
        </div>
      </div>
    </div>
  );
}

export default SignInScreen;
